/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./contentRights.defs.js";
export { main as default } from "./contentRights.defs.js";
